import {
  CurrencyDto,
  CustomerCardInfo,
  CustomerDailyChangeDto,
  CustomerTransactionStatus,
  CustomerTransactionType,
  CustomerTransactionV2Dto,
  ErrorModel,
  TradingType,
  WalletAccountV2Dto,
  WalletConfigurationDto,
  WalletCurrencyV2Dto,
  WalletType,
} from 'common/api/autogenerated/client-area';

import { loadWalletTransactionsFiltersInSessionStorage } from './wallet.mapper';

export type WalletAccountV2DtoExtended = WalletAccountV2Dto &
  Pick<WalletCurrencyV2Dto, 'decimalPlaces' | 'availableAccountTypes'> & {
    balanceIsUpdated?: boolean;
  };
export type WalletCurrencyV2DtoExtended = WalletCurrencyV2Dto & {
  balanceIsUpdated?: boolean;
};

export type StateWallets = Record<string, WalletCurrencyV2DtoExtended>;

export type WalletTransactionsFiltersType = {
  currencyType?: WalletType;
  currency?: string;
  search?: string;
  dateFrom?: Date | undefined;
  dateTo?: Date | undefined;
  accountTradingType?: TradingType;
  types?: CustomerTransactionType[];
  status?: CustomerTransactionStatus;
};

export const walletsInitialState: {
  balance: CustomerDailyChangeDto;
  currencies: Array<CurrencyDto>;
  accounts: {
    main: WalletAccountV2DtoExtended[];
    derivatives: WalletAccountV2DtoExtended[];
    earn: WalletAccountV2DtoExtended[];
    stocks: WalletAccountV2DtoExtended[];
  };
  wallets: StateWallets;
  configuration: WalletConfigurationDto;
  transactions: {
    loading: boolean;
    filters: WalletTransactionsFiltersType;
    list: CustomerTransactionV2Dto[];
  };
  paymentCard?: CustomerCardInfo;
  paymentCardLoading: boolean;
  loading: boolean;
  currenciesLoading: boolean;
  initialLoading: boolean;
  currenciesInitialLoading: boolean;
  error?: ErrorModel;
} = {
  balance: {
    totalBalanceUsd: null,
    dailyChange: {},
  },
  currencies: [],
  accounts: {
    main: [],
    derivatives: [],
    earn: [],
    stocks: [],
  },
  wallets: {},
  configuration: {},
  transactions: {
    loading: false,
    filters: {
      ...loadWalletTransactionsFiltersInSessionStorage(),
      currency: undefined,
    },
    list: [],
  },
  paymentCard: undefined,
  paymentCardLoading: true,
  loading: false,
  initialLoading: true,
  currenciesLoading: true,
  currenciesInitialLoading: true,
  error: undefined,
};
